import { FC } from 'react';

import { PageMetadata } from '@/shared';

const Metadata: FC = () => <PageMetadata context='Search' description='Search companies.' segments={['Companies']} />;

export default Metadata;
